import { motion, useInView } from "framer-motion";
import React, { useRef } from "react";
import "./SatisfiedCustomers.css";
import { STANDARD_VARIANTS } from "../constants/animations";
import { CONTAINER_STYLES, TYPOGRAPHY_STYLES } from "../constants/styles";

interface Customer {
    name: string;
    logo: string;
}

const customers: Customer[] = [
    { name: "Matrix", logo: "matrix.png" },
    { name: "Ministry of Defense", logo: "ministry-of-defense.svg" },
    { name: "BGU", logo: "bgu.png" },
    { name: "Mixtiles", logo: "mixtiles.png" },
    { name: "Osta", logo: "osta.png" },
    { name: "Mada", logo: "mada.svg" },
    { name: "Guy Koren Schools", logo: "guy-koren.png" },
    { name: "Red Alpha", logo: "red-alpha.png" },
    { name: "Rounds", logo: "rounds.png" },
];


const SatisfiedCustomers: React.FC = () => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, amount: 0.3 });

    return (
        <motion.div
            ref={ref}
            className={CONTAINER_STYLES.section}
            initial="hidden"
            animate={isInView ? "visible" : "hidden"}
            variants={STANDARD_VARIANTS.container}
        >
            <motion.h2
                className={TYPOGRAPHY_STYLES.sectionTitle}
                variants={STANDARD_VARIANTS.item}
            >
                Trusted by
            </motion.h2>

            <motion.div
                className="mt-16 max-w-3xl mx-auto relative py-8"
                variants={STANDARD_VARIANTS.item}
            >
                <div className="overflow-hidden relative logo-belt">
                    <Banner images={customers.map(customer => ({
                        name: customer.name,
                        logo: require(`../images/companies/${customer.logo}`)
                    }))} />
                </div>
            </motion.div>
        </motion.div>
    );
};

interface BannerProps {
    images: { name: string; logo: string }[];
    speed?: number;
}

const Banner: React.FC<BannerProps> = ({ images, speed = 40000 }) => (
    <div className="h-24 overflow-hidden">
        <div className="wrapper">
            {[...Array(3)].map((_, index) => (
                <section
                    key={index}
                    className="section"
                    style={{ "--speed": `${speed}ms` } as React.CSSProperties}
                >
                    {images.map(({ name, logo }) => (
                        <div key={name}>
                            <img src={logo} alt={name} className="mx-16 w-24 h-24 object-contain brightness-0 opacity-60 dark:invert dark:opacity-70" />
                        </div>
                    ))}
                </section>
            ))}
        </div>
    </div>
);

export default SatisfiedCustomers;
